<template>
  <div class="scatterplots" :class="isAutoExportPng ? 'autoExportPng' : ''">
    <div class="scatter_plot">
      <div
        ref="scatterplot"
        id="scatterplot"
        style="width: 100%; height: 100%"
        @click.stop="downLoad($refs.scatterplot, true)"
      ></div>
    </div>
    <div class="player_line" v-if="!isAutoExportPng">
      <span
        v-text="`X：${echartData.statisticsModels[0].statisticsName}`"
      ></span>
      <span
        v-text="`Y：${echartData.statisticsModels[1].statisticsName}`"
      ></span>
    </div>
    <div class="scatter_plot_right" v-if="isShowPlayerNameTip">
      <div class="player_num">
        <p v-for="(item, idx) in dimensionNames" :key="idx">
          <i class="cicles" :style="{ background: background[idx] }"></i>
          <span v-text="item"></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import datas from './coordinateSystemScatter.json'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'coordinateSystemScatter',
  mixins: [canvasToImage_base64_data_mixin],
  props: {
    // echartData: {
    //   default: function () {
    //     return {}
    //   },
    // },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowPlayerNameTip: false,
      descruptData: [],
      dataResult: [],
      ItemData: [],
      dimensionNames: [],
      resultData: [],
      background: [
        '#2F4554',
        '#749F83',
        '#D48265',
        '#C23531',
        '#61A0A8',
        '#CA8622',
      ],
      initFlag: false,
      myChart: null,
    }
  },
  created() {
    this.echartData = datas
  },
  mounted() {
    this.$nextTick(() => {
      this.initdata()
      this.initFlag = true
      this.ScatterPlot()
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myChart) {
      this.myChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.echartData = null
  },
  components: {},
  watch: {
    echartData(val) {
      if (this.initFlag) {
        this.initdata()
        this.ScatterPlot()
        this.dataResult = []
      }
    },
  },
  methods: {
    initdata() {
      this.resultData = this.echartData.resultData
      this.dimensionNames = this.echartData.dimensionNames
      console.debug('this.dimensionNames:', this.dimensionNames)
    },
    ScatterPlot() {
      this.ItemData = []
      this.dataResult = []
      this.resultData.forEach((element) => {
        let tmp = []
        tmp.push(element)
        this.dataResult.push(tmp)
      })
      if (this.dimensionNames.length == 0) {
        this.dataResult = [[], [], [], [], [], []]
        this.dataResult.forEach((item, index) => {
          this.ItemData.push({
            name: '',
            data: item,
            type: 'scatter',
            symbolSize: function (data) {
              return Math.sqrt(parseInt(data[2]) * 4)
            },
            label: {
              emphasis: {
                show: true,
                formatter: function (param) {
                  return param.data[3]
                },
                position: 'top',
              },
            },
            itemStyle: {
              normal: {
                shadowColor: '',
              },
            },
          })
        })
      } else {
        this.dataResult.forEach((item, index) => {
          this.ItemData.push({
            name: '',
            data: item,
            type: 'scatter',
            symbolSize: function (data) {
              return Math.sqrt(parseInt(data[2]) * 4)
            },
            label: {
              emphasis: {
                show: true,
                formatter: function (param) {
                  return param.data[3]
                },
                position: 'top',
              },
            },
            itemStyle: {
              normal: {
                shadowColor: '',
              },
            },
          })
        })
      }
      this.myChart = this.$echarts.init(this.$refs.scatterplot)
      this.myChart.setOption({
        backgroundColor: ' #fff',
        color: [
          '#2F4554',
          '#749F83',
          '#D48265',
          '#C23531',
          '#61A0A8',
          '#CA8622',
        ],
        title: {},
        grid: {
          left: '0%',
          right: '7.5%',
          top: '18%',
          bottom: '5%',
          containLabel: true,
        },
        legend: {
          right: 10,
          // y: 'top',
          data: [
            '切特里',
            '当达',
            '日尔加尔别克乌卢',
            '刘洋',
            '乌丹塔',
            '德格内克',
          ],
          itemStyle: {
            normal: {
              label: {
                show: true, //显示文本
                position: 'inside', //数据值位置
                // formatter: '{c}%',
                textStyle: {
                  color: '#000',
                  fontSize: '14',
                },
              },
            },
          },
        },
        xAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#999',
              fontSize: 10,
            },
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
            },
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#999', //左边线的颜色
            },
          },
        },
        yAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#999',
              fontSize: 10,
            },
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
            },
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#999', //左边线的颜色
              width: 0.5,
            },
          },
        },
        //循环的数据
        series: this.ItemData,
      })

      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(this.$refs.scatterplot, true, 'uploadData')
        }, 500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.scatterplots {
  position: relative;
  width: 80%;
  height: 80%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  &.autoExportPng {
    width: 100%;
    height: 100%;
  }
  .scatter_plot_right {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 10px;
    // padding-top: 5%;
    padding-bottom: 6%;
    .player_num {
      p {
        line-height: 1.736vw;
        text-align: left;
        i {
          margin-right: 0.347vw;
        }
        span {
          display: inline-block;
          text-align: left;
          font-size: 0.833vw;
          color: #b9b9b9;
          letter-spacing: 0;
          text-align: center;
        }
        .cicles {
          display: inline-block;
          width: 0.694vw;
          height: 0.694vw;
          border-radius: 50%;
        }
      }
    }
  }
  .player_line {
    position: absolute;
    top: -3%;
    left: 0;
    z-index: 2;
    span {
      display: inline-block;
      padding-right: 1.388vw;
      font-size: 0.833vw;
      line-height: 1.388vw;
      color: var(--mixtmt_greyColor_main);
    }
  }
  .scatter_plot {
    width: 100%;
    height: 100%;
  }
}
</style>
